<template>
  <div class="vx-col w-full">
    <vx-card class="digitelex-popup-content">
      <form>
        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <vs-input
              v-validate="'required|alpha_num|min:2'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Location Name"
              label-placeholder="Location Name"
              autocomplete="nope"
              name="locationName"
              v-model="frm.locationName"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('locationName')"
              ><span class="digitelex-form-error-message">{{
                errors.first("locationName")
              }}</span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('locationName')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-2">
            <vs-input
              v-validate="'required|alpha_num|min:1|max:3'"
              data-vv-validate-on="input|keyup|blur|click"
              class="w-full"
              placeholder="Location Short Name"
              label-placeholder="Location Short  Name"
              name="locationShortName"
              autocomplete="nope"
              v-model="frm.locationShortName"
            />
            <span
              class="text-danger text-sm digitelex-form-error-message-container"
              v-if="errors.has('locationShortName')"
              ><span class="digitelex-form-error-message">{{
                errors.first("locationShortName")
              }}</span>
              <vx-tooltip
                position="bottom"
                :text="errors.first('locationShortName')"
              >
                <vs-button
                  size="small"
                  radius
                  color="danger"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-info"
                ></vs-button>
              </vx-tooltip>
            </span>
          </div>
        </div>
        <div class="flex flex-wrap justify-end">
          <vs-button
            :disabled="!validateForm"
            @click="saveLocation"
            class="ml-auto"
            >Save Changes</vs-button
          >
          <vs-button class="ml-4" @click="frm = {}" color="danger"
            >Reset</vs-button
          >
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
const dict = {
  custom: {
    clientName: {
      required: "Please enter your first name",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};

Validator.localize("en", dict);

export default {
  props: {
    frmData: {},
  },
  methods: {
    saveLocation() {
      if (this.frm.locationId) {
        //Update
        // alert("Updated");
        this.$http
          .put("common/location", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            let message = error.response.data.message;
            this.$vs.dialog({
              color: "danger",
              title: `Error in Editing location`,
              text: `${message}`,
              accept: console.log(error.response.data.message),
            });
          });
      } else {
        this.frm.locationId = 0;
        this.frm.isActive = true;
        this.$http
          .post("common/location", this.frm)
          .then((response) => {
            this.$emit("submitResponse", response);
          })
          .catch((error) => {
            let message = error.response.data.message;
            this.$vs.dialog({
              color: "danger",
              title: `Error in Adding location`,
              text: `${message}`,
              accept: console.log(error.response.data.message),
            });
          });
      }
    },
  },
  data() {
    return {
      frm: {
        locationId: 0,
        locationName: null,
        locationShortName: null,
        isActive: true,
      },
    };
  },
  watch: {
    frmData: {
      handler(after) {
        this.frm = after;
      },
      immediate: true,
    },
  },

  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.frm.locationName != "" &&
        this.frm.locationName != null
      );
    },
  },
  beforeMount() {
    console.log(this.frmData);
  },
};
</script>
<style>
.vs-dialog-danger {
  z-index: 99999999999999999;
}
</style>
